import OpenOrderList from 'components/OpenOrderList';

export default function OpenOrders() {
  return (
    <div className='flex flex-col gap-2 pb-[20px] h-full'>
      <OpenOrderList />
    </div>
  );
}
